export function clientSideSearchData(state = { wasRequested: false, loading: false, data: [] }, action) {
  switch (action.type) {
    case 'RECEIVE_CLIENT_SIDE_SEARCH_DATA_RESOURCE':
      return { ...state, wasRequested: true, loading: false, data: [...state.data, ...action.data] };
    case 'REQUEST_CLIENT_SIDE_SEARCH_DATA_RESOURCE':
      return { ...state, loading: true };
    default:
      return state;
  }
}
